import { interpolateColor } from '@/helpers';

// Color scale constants
const COLOR_PURPLE = '#7C3AED';
const COLOR_GRAY = '#71717A';
const COLOR_YELLOW = '#D97706';
const COLOR_RED = '#DC2626';

/**
 * Returns a color based on a numeric value using a predefined color scale with gradient interpolation
 *
 * Color scale breakpoints:
 * - < 0: Solid red (#DC2626)
 * - 0-50: Gradient from red (#DC2626) to yellow (#D97706)
 * - 50-100: Gradient from yellow (#D97706) to gray (#71717A)
 * - > 100: Solid purple (#7C3AED)
 *
 * @param value - Numeric value to determine color (typically 0-100 but supports any range)
 * @returns Hex color string (e.g., "#DC2626")
 *
 * @example
 * getColorScale(-10)   // → "#DC2626" (solid red)
 * getColorScale(0)     // → "#DC2626" (red)
 * getColorScale(25)    // → (midpoint between red and yellow)
 * getColorScale(50)    // → "#D97706" (yellow)
 * getColorScale(75)    // → (midpoint between yellow and gray)
 * getColorScale(100)   // → "#71717A" (gray)
 * getColorScale(150)   // → "#7C3AED" (solid purple)
 */
export function getTimelineCellColorScale(value: number): string {
  if (value < 0) {
    return COLOR_RED;
  }

  if (value <= 50) {
    const factor = value / 50;
    return interpolateColor(COLOR_RED, COLOR_YELLOW, factor);
  }

  if (value <= 100) {
    const factor = (value - 50) / 50;
    return interpolateColor(COLOR_YELLOW, COLOR_GRAY, factor);
  }

  return COLOR_PURPLE;
}
